import { createFileRoute, redirect } from "@tanstack/react-router";
import { isLoggedIn } from "@/hooks/useAuth";
import { ClientDashboardLayout } from "@/layouts/ClientDashboardLayout";
import { checkIsSuperuser } from "@/lib/utils";

export const Route = createFileRoute("/_authenticated")({
  beforeLoad: async () => {
    if (!isLoggedIn()) {
      throw redirect({ to: "/login" });
    }

    const isSuperuser = checkIsSuperuser();
    if (isSuperuser) {
      throw redirect({ to: "/admin/users" });
    }
  },
  component: ClientDashboardLayout,
});
